import { render, staticRenderFns } from "./ChatFiltersConfigList.vue?vue&type=template&id=57055a3e&scoped=true&"
import script from "./ChatFiltersConfigList.vue?vue&type=script&lang=ts&"
export * from "./ChatFiltersConfigList.vue?vue&type=script&lang=ts&"
import style0 from "./ChatFiltersConfigList.vue?vue&type=style&index=0&id=57055a3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57055a3e",
  null
  
)

export default component.exports